
import React, { useEffect, useState, useRef } from 'react';
import { useAppContext } from '../../context/AppContext';
import { Delete, Edit } from 'lucide-react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { toast } from 'react-toastify';
import axios from 'axios';
import AddProduct from './AddProduct';
import {StyledButton} from '../../Shared'
import Modal from '../../modals/Modal';
import CalcForm from './CalForm'


const Products = () => {
  const { axiUrl } = useAppContext();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [items, setItems] = useState([]);
  const [product, setProduct] = useState(null);
  const [reset, setReset] = useState(true);
  const [editItemId, setEditItemId] = useState(null);
    const [calcOpen, setCalcOpen] = useState(false);
  
  const formRef = useRef(null);



  // Fetch default products
  useEffect(() => {
    const getDefaults = async () => {
      try {
        const response = await axios.get(`${axiUrl}/products/getdefaultproducts`);
        console.log(response)
        if (response.status === 200) {
        console.log(response.data);
        setItems(response.data.data);
        } else {
          toast.error(response.data.message || 'Failed to fetch default products');
        }
      } catch (err) {
        console.error('Error fetching default products:', err);
        toast.error('Error fetching default products');
      }
    };
    getDefaults();
  }, [reset]);

  // Scroll to form when it opens
  useEffect(() => {
    const check = async() => {
  if(isFormOpen  === false){
  await  setProduct(null)
   await setEditItemId(null)
  }
      }
      check()
  }, [isFormOpen]);

  // Handle animation state
  useEffect(() => {
    // if (isFormOpen) {
    //   setIsAnimating(true); // Make visible immediately for opening
    // } else {
    //   const timer = setTimeout(() => setIsAnimating(false), 300); // Hide after closing animation
    //   return () => clearTimeout(timer);
    // }
  }, [isFormOpen]);







  const handleEdit = (item) => {
    setEditItemId(item._id);
    setProduct({
      id: item._id,
      name: item.name,
      weightType: item.type || 'Standard Letter',
      weight: item.weight,
      weightUnit: item.weightUnit || 'oz',
      thickness: item.thickness,
      machinable: item.machinable,
      width: item.width,
      length: item.length,
      paperType: item.paperType || 'Standard',
      company: item.company || null,
      weightType:item.weightType
    });
    setIsFormOpen(true);
  };

 

  const removeProduct = async (id) => {
    try {
      const res = await axios.post(`${axiUrl}/products/remove`, { id });
      if (res.data.status === 200) {
        toast.success(res.data.message);
        setReset(!reset);
      } else {
        toast.error(res.data.message || 'Failed to remove product');
      }
    } catch (err) {
      console.error('Error removing product:', err);
      toast.error('Error removing product');
    }
  };

  return (
    <>
    <Modal
    show={isFormOpen}
    onClose={() => setIsFormOpen(false)}
        // header="My Modal"
        // width="50%"
        // contentBgColor="#f9f9f9"
        // headerTextAlign="center"
        // headerBgColor="#007bff"
        // headerColor="white"
   
    >
      <AddProduct company='6841d157e3c375b19c72fe23' setCalcOpen={setCalcOpen} setProduct={setProduct}  product={product || null} editItemId={editItemId || null} setReset={setReset}  reset={reset} onClose={() => setIsFormOpen(false)}/>
    </Modal>
           <Modal
         show={calcOpen}
         onClose={() => setCalcOpen(false)}
             // header="My Modal"
             // width="50%"
             // contentBgColor="#f9f9f9"
             // headerTextAlign="center"
             // headerBgColor="#007bff"
             // headerColor="white"
        
         >
           <CalcForm onClose={() => setCalcOpen(false)}/>
         </Modal>
         <Tabs>
           <TabList>
              <Tab>Default LPS Products</Tab>
              <Tab>Customer Products</Tab>
              <Tab></Tab>
            </TabList>
            <TabPanel>
               <div className='w-full px-[20px] py-[10px]'>
            <div className="flex justify-start items-center mb-6">
        <div className='flex'><StyledButton size="small" onClick={() => setIsFormOpen(true)}>Add Product</StyledButton></div>
        </div>
       
              {/* Active Jobs Table */}
      <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md mb-4">
         <div className="bg-white shadow-md rounded-lg overflow-hidden ">
          <table className="min-w-full divide-y divide-gray-200 box-borde">
            <thead className="bg-gray-50">
              <tr className='flex'>
                <th className="flex-3 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className=" flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Width (in)</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Length (in)</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Weight</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Thickness (in)</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {items?.map((item) => (
                <tr key={item._id} className='flex'>
                  <td className=" flex-3 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.name}</td>
                  <td className=" flex-1  px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.width}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.length}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.weight} {item?.weightUnit}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.thickness}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex space-x-2">
                    <Edit
                      color="rgba(0,0,255,0.5)"
                      size={18}
                      onClick={() => handleEdit(item)}
                      className="cursor-pointer"
                    />
                    <Delete
                      color="rgba(255,0,0,0.5)"
                      size={18}
                      onClick={() => removeProduct(item?._id)}
                      className="cursor-pointer"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
            </TabPanel>
            <TabPanel><div className='w-full px-[20px] py-[10px] '>
            <div className="flex justify-start items-center mb-6">
         <div className='flex'><StyledButton size="small" onClick={() => setIsFormOpen(true)}>Add Product</StyledButton></div>
        </div>
        <div className='w-full text-lg font-bold'>Customer Products</div>
              {/* Active Jobs Table */}
      <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md mb-4">
         <div className="bg-white shadow-md rounded-lg overflow-hidden ">
          <table className="min-w-full divide-y divide-gray-200 box-borde">
            <thead className="bg-gray-50">
              <tr className='flex'>
                <th className="flex-3 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className=" flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Width (in)</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Length (in)</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Weight</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Thickness (in)</th>
                <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {items?.map((item) => (
                <tr key={item._id} className='flex'>
                  <td className=" flex-3 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.name}</td>
                  <td className=" flex-1  px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.width}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.length}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.weight} {item?.weightUnit}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.thickness}</td>
                  <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex space-x-2">
                    <Edit
                      color="rgba(0,0,255,0.5)"
                      size={18}
                      onClick={() => handleEdit(item)}
                      className="cursor-pointer"
                    />
                    <Delete
                      color="rgba(255,0,0,0.5)"
                      size={18}
                      onClick={() => removeProduct(item?._id)}
                      className="cursor-pointer"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div></TabPanel>
         </Tabs>

   

    
    </>
  );
};

export default Products;


//bi-fold tri-fold selfmailer